import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { PxMark } from "@/components/PxMark";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center text-center">
        <PxMark state="error" size={24} />
        <h1 className="mt-6 text-[28px] font-semibold tracking-[-0.01em] text-foreground">404</h1>
        <p className="mt-2 text-sm text-muted-foreground">Cette page n'existe pas.</p>
        <a
          href="/"
          className="mt-6 text-[13px] text-muted-foreground underline-offset-[3px] transition-colors hover:text-foreground hover:underline"
        >
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
};

export default NotFound;
